import { CpuChipIcon, DocumentArrowUpIcon } from '@heroicons/react/24/solid'
import { Bot, Database, Server, Thermometer } from 'lucide-react'
import {
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '../ui/sidebar'
import { cn } from '@/lib/utils'

export enum AIPlayerSection {
  PERSONA = 'persona',
  MODEL_CONFIG = 'modelConfig',
  RAG_CONFIG = 'ragConfig',
  UPLOAD = 'upload',
  LLM_PREFERENCE = 'llmPreference',
  MCP_SERVER = 'mcpServer',
}

const sidebarOptions = [
  { key: AIPlayerSection.PERSONA, label: 'Persona & Behavior', icon: Bot },
  {
    key: AIPlayerSection.MODEL_CONFIG,
    label: 'Model Configuration',
    icon: Thermometer,
  },
  { key: AIPlayerSection.RAG_CONFIG, label: 'RAG Configuration', icon: Database },
  { key: AIPlayerSection.UPLOAD, label: 'Upload Files', icon: DocumentArrowUpIcon },
  {
    key: AIPlayerSection.LLM_PREFERENCE,
    label: 'LLM Preference',
    icon: CpuChipIcon,
  },
  { key: AIPlayerSection.MCP_SERVER, label: 'MCP Servers', icon: Server },
]

interface Props {
  activeSection: AIPlayerSection
  onSectionChange: (section: AIPlayerSection) => void
}

export default function AIPlayerConfigSideBar({
  activeSection,
  onSectionChange,
}: Props) {
  return (
    <div className='w-80 bg-gray-50 border-r border-gray-200'>
      <SidebarContent className='p-6 h-full'>
        <SidebarGroup>
          <SidebarGroupLabel className='text-xl font-bold text-gray-900 mb-6'>
            Configuration
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu className='space-y-2'>
              {sidebarOptions.map((option) => {
                const IconComponent = option.icon
                return (
                  <SidebarMenuItem key={option.key}>
                    <SidebarMenuButton
                      onClick={() => onSectionChange(option.key)}
                      className={cn(
                        'w-full text-left p-4 rounded-lg transition-colors flex items-start gap-3 h-auto min-h-[60px] border',
                        activeSection === option.key
                          ? 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-50'
                          : 'text-gray-700 hover:bg-gray-50 border-transparent hover:border-gray-200'
                      )}
                    >
                      <IconComponent className='w-5 h-5 mt-0.5 flex-shrink-0' />
                      <div className='flex-1 text-left'>
                        <div className='font-medium'>{option.label}</div>
                      </div>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                )
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </div>
  )
}
